import React from "react";
import { CtaButton } from "./CtaButton";
interface StickyOfferBarProps {
  visible: boolean;
}
export function StickyOfferBar({
  visible
}: StickyOfferBarProps) {
  if (!visible) return null;
  return <div className="sticky-offer" role="region" aria-label="Kit offer" data-id="element-206" data-mp="2p6xsirevo377">
      <div className="shell" data-id="element-207" data-mp="2k8o18rw9xmqv">
        <p data-id="element-208" data-mp="2k7l8eefe5a8b">
          <strong data-id="element-209" data-mp="2k7v0q8nwrth6">Team Communication Ready</strong>
          <span data-id="element-210" data-mp="2f9jq3vpshexw">Complete guide · 5 workshops + 5 bonuses · $27 USD one time</span>
        </p>
        <CtaButton href="#offer-details" small data-id="element-211" data-mp="2aagji6u5v0nt">
          See offer — $27
        </CtaButton>
      </div>
    </div>;
}